export default __webpack_public_path__ + "static/media/php-icon.8695a27b.svg";